import React, { useState } from 'react';
import './BrickCharts.css';
import BillboardChart from './BrickCharts/BillboardChart';
import LastFMCharts from './BrickCharts/LastFMCharts';
import ChartSearch from './BrickCharts/ChartSearch';
import ChartExporter from './BrickCharts/ChartExporter';
import TrendAnalysis from './BrickCharts/TrendAnalysis';
import HealthMonitor from './BrickCharts/HealthMonitor';

function BrickCharts() {
  const [activeTab, setActiveTab] = useState('billboard');
  const [selectedChart, setSelectedChart] = useState('hot-100');

  const tabs = [
    { id: 'billboard', label: 'Billboard Charts', icon: '📊' },
    { id: 'lastfm', label: 'Last.FM Charts', icon: '🌐' },
    { id: 'search', label: 'Search & Filter', icon: '🔍' },
    { id: 'trends', label: 'Trend Analysis', icon: '📈' },
    { id: 'export', label: 'Export Data', icon: '📤' },
    { id: 'health', label: 'Health Monitor', icon: '💚' }
  ];

  return (
    <div className="brickcharts-page">
      <header className="brickcharts-header">
        <div className="header-content">
          <h1>🎵 BrickCharts Library</h1>
          <p>Comprehensive music chart analysis and visualization toolkit</p>
          <div className="header-features">
            <span className="feature">📊 Billboard Integration</span>
            <span className="feature">🌐 Last.FM Support</span>
            <span className="feature">🔍 Advanced Search</span>
            <span className="feature">📈 Trend Analysis</span>
            <span className="feature">📤 Data Export</span>
            <span className="feature">💾 Smart Caching</span>
          </div>
        </div>
      </header>

      <nav className="brickcharts-nav">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </nav>

      <main className="brickcharts-content">
        {activeTab === 'billboard' && (
          <div className="tab-content">
            <div className="content-header">
              <h2>Billboard Charts</h2>
              <p>Real-time access to Billboard's most popular music charts</p>
            </div>
            <div className="chart-selector">
              <label htmlFor="chart-type">Select Chart Type:</label>
              <select 
                id="chart-type"
                value={selectedChart} 
                onChange={(e) => setSelectedChart(e.target.value)}
              >
                <option value="hot-100">Hot 100</option>
                <option value="billboard-200">Billboard 200</option>
                <option value="artist-100">Artist 100</option>
                <option value="pop-songs">Pop Songs</option>
                <option value="country-songs">Country Songs</option>
                <option value="r-b-hip-hop-songs">R&B/Hip-Hop Songs</option>
                <option value="dance-electronic-songs">Dance/Electronic Songs</option>
                <option value="rock-songs">Rock Songs</option>
              </select>
            </div>
            <BillboardChart chartType={selectedChart} />
          </div>
        )}

        {activeTab === 'lastfm' && (
          <div className="tab-content">
            <div className="content-header">
              <h2>Last.FM Charts</h2>
              <p>Global music trends and listening data from Last.FM</p>
            </div>
            <LastFMCharts />
          </div>
        )}

        {activeTab === 'search' && (
          <div className="tab-content">
            <div className="content-header">
              <h2>Search & Filter</h2>
              <p>Advanced search capabilities across multiple chart sources</p>
            </div>
            <ChartSearch />
          </div>
        )}

        {activeTab === 'trends' && (
          <div className="tab-content">
            <div className="content-header">
              <h2>Trend Analysis</h2>
              <p>Analyze chart movements and identify trending artists</p>
            </div>
            <TrendAnalysis chartType={selectedChart} />
          </div>
        )}

        {activeTab === 'export' && (
          <div className="tab-content">
            <div className="content-header">
              <h2>Export Data</h2>
              <p>Export chart data in multiple formats for analysis</p>
            </div>
            <ChartExporter chartType={selectedChart} />
          </div>
        )}

        {activeTab === 'health' && (
          <div className="tab-content">
            <div className="content-header">
              <h2>Health Monitor</h2>
              <p>Monitor service health and performance metrics</p>
            </div>
            <HealthMonitor />
          </div>
        )}
      </main>

      <footer className="brickcharts-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>BrickCharts Library</h3>
            <p>A powerful toolkit for music chart analysis and visualization</p>
          </div>
          <div className="footer-section">
            <h4>Features</h4>
            <ul>
              <li>Real-time Billboard data</li>
              <li>Last.FM integration</li>
              <li>Advanced search & filtering</li>
              <li>Trend analysis</li>
              <li>Data export capabilities</li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Documentation</h4>
            <ul>
              <li><a href="https://github.com/aribradshaw/brickcharts" target="_blank" rel="noopener noreferrer">GitHub Repository</a></li>
              <li><a href="/docs/api-reference" target="_blank" rel="noopener noreferrer">API Reference</a></li>
              <li><a href="/docs/getting-started" target="_blank" rel="noopener noreferrer">Getting Started</a></li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default BrickCharts; 